<template>
  <v-flex >
    <p class="headline" v-html="$t('tutorial.stepWhatIs.TITLE')"></p>
    <p class="subheading" style="text-align: justify" v-html="$t('tutorial.stepWhatIs.BODY')"></p>
    <v-container>
      <v-layout>
        <v-btn @click.native="$emit('back')" flat>{{ $t('tutorial.buttons.BACK') }}</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary" :disabled="selected < 3" @click.native="$emit('continue')">{{ $t('tutorial.buttons.CONTINUE') }}</v-btn>
      </v-layout>
    </v-container>
  </v-flex>
</template>

<script>
  export default {
    name: 'tutorial-step2'
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/tutorial/TutorialStep2.vue